import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { DirectCharge } from './directCharge.model';

@Injectable({
  providedIn: 'root'
})
export class DirectChargeService {

  constructor(private http: HttpClient, private global: Globle) { }

  get(status: number, userId: string, fromDate: string, toDate: string, api: boolean) {
    return this.http.get<DirectCharge[]>(this.global.APIURL + "directcharge/get?status=" + status +
      "&userId=" + userId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&api=" + api);
  }

  updateNotSeen() {
    return this.http.put(this.global.APIURL + "directcharge/updatenotseen", "");
  }


  updateStatus(obj: any) {
    return this.http.put(this.global.APIURL + "directcharge/updatestatus", obj);
  }

  getNotSeenCount() {
    return this.http.get<number>(this.global.APIURL + "directcharge/getnotseen");
  }
}
